exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-address[data-v-402f64e8]{padding:0 10px;font-size:12px;font-weight:700;text-decoration:none;white-space:nowrap;transition:color .2s ease;color:hsla(0,0%,100%,.6)}.nav-address.active[data-v-402f64e8]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-402f64e8","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavAddress.vue
// module id = 23
// module chunks = 0